import '../te-spacing';
import '../te-text';
import { html, css, TemplateResult } from 'lit';
import { property, state } from 'lit/decorators.js';
import { booleanConverter } from '../common/converters';
import { TeComponent } from '../common/te-component';
import { theme } from '../common/theme';
import { StyleInfo, styleMap } from 'lit/directives/style-map';

/** Base Button Component */
export class TeButtonBase extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      button {
        display: flex;
        align-items: center;
        border-radius: 4px;
        height: 40px;
        min-width: 40px;
        border: 0;
        padding: 0 24px;
        cursor: pointer;
        max-width: 100%;
        overflow: hidden;
        margin: 0;
      }

      [disabled] {
        cursor: default;
      }

      te-text {
        overflow: hidden;
      }
    `,
  ];

  /** Background color of button */
  @property({ type: String }) backgroundColor?: string;
  /** Button is disabled */
  @property({
    type: Boolean,
    converter: booleanConverter,
  })
  disabled = false;

  @state() hovered = false;

  handleButtonMouseOver() {
    this.hovered = true;
  }
  handleButtonMouseOut() {
    this.hovered = false;
  }
  getBackgroundColor() {
    return theme.colors.primary.v0.toString();
  }
  getTextColor() {
    return theme.colors.text.toString();
  }
  getStyle(): StyleInfo {
    return {
      backgroundColor: this.getBackgroundColor(),
    };
  }
  getButtonClass() {
    return '';
  }
  renderIcon(): TemplateResult<1> | void {
    return;
  }
  renderText(): TemplateResult<1> | void {
    return;
  }
  renderLoader(): TemplateResult<1> | void {
    return;
  }

  render() {
    return html`
      <button
        ?disabled="${this.disabled}"
        class=${this.getButtonClass()}
        id="${this.testId}"
        style=${styleMap(this.getStyle())}
        @click=${this.handleClick}
        @mouseover=${this.handleButtonMouseOver}
        @mouseout=${this.handleButtonMouseOut}
      >
        ${this.renderIcon()} ${this.renderText()} ${this.renderLoader()}
      </button>
    `;
  }
}
